import React, { useCallback } from "react";
import { IndustriesFilter } from "../Industries/IndustriesFilter";
import { IndustriesPayload } from "../Industries/types";
import { useFiltersContext } from "../../../pages/Workspace/UserFilters/FiltersContext";
import { isEmpty } from "../../../utils/jsUtils";
import { useInsideFilterChip } from "../../../pages/Workspace/UserFilters/FiltersChips/hooks/useInsideFilterChip";
import { FilterLayout } from "./FilterLayout";

const isAllIndustriesEmpty = (industries: IndustriesPayload): boolean => {
  return (
    isEmpty(industries?.industryIds) &&
    isEmpty(industries?.sicIds) &&
    isEmpty(industries?.naicsIds) &&
    isEmpty(industries?.excludedIds) &&
    isEmpty(industries?.excludedSicIds) &&
    isEmpty(industries?.excludedNaicsIds)
  );
};

export const IndustryFilter: React.FC = () => {
  const { draftFilters, setDraftFilters } = useFiltersContext();
  const { insideChip, elementRef } = useInsideFilterChip();

  const selectedValues: IndustriesPayload = {
    industryIds: draftFilters?.industry?.industryIds || [],
    sicIds: draftFilters?.industry?.sicUS1987Ids || [],
    naicsIds: draftFilters?.industry?.naics2012Ids || [],
    excludedIds: draftFilters?.industry?.excludedIndustryIds || [],
    excludedSicIds: draftFilters?.industry?.excludedSicUS1987Ids || [],
    excludedNaicsIds: draftFilters?.industry?.excludedNaics2012Ids || [],
  };

  const handleValuesChange = useCallback(
    (payload: IndustriesPayload) => {
      if (isAllIndustriesEmpty(payload)) {
        setDraftFilters((prevDraftFilters) => ({
          ...prevDraftFilters,
          industry: undefined,
        }));
        return;
      }

      setDraftFilters((prevDraftFilters) => ({
        ...prevDraftFilters,
        industry: {
          industryIds: !isEmpty(payload.industryIds)
            ? payload.industryIds
            : undefined,
          sicUS1987Ids: !isEmpty(payload.sicIds) ? payload.sicIds : undefined,
          naics2012Ids: !isEmpty(payload.naicsIds)
            ? payload.naicsIds
            : undefined,
          excludedIndustryIds: !isEmpty(payload.excludedIds)
            ? payload.excludedIds
            : undefined,
          excludedSicUS1987Ids: !isEmpty(payload.excludedSicIds)
            ? payload.excludedSicIds
            : undefined,
          excludedNaics2012Ids: !isEmpty(payload.excludedNaicsIds)
            ? payload.excludedNaicsIds
            : undefined,
        },
      }));
    },
    [setDraftFilters]
  );

  const handleClearFilter = useCallback(() => {
    setDraftFilters((prevDraftFilters) => ({
      ...prevDraftFilters,
      industry: undefined,
    }));
  }, [setDraftFilters]);

  return (
    <FilterLayout
      title="Industry"
      onClear={handleClearFilter}
      showHeader={!insideChip}
      refProp={elementRef}
      id="industry-filter"
    >
      <IndustriesFilter
        id="user-industries-filter"
        showExcluded
        selectedValues={selectedValues}
        onValuesChange={handleValuesChange}
      />
    </FilterLayout>
  );
};
